import zil from '~img/farmsBridgesStake/zil.png'
import bsc from '~img/farmsBridgesStake/bsc.png'
import eth from '~img/farmsBridgesStake/eth.png'
import pol from '~img/farmsBridgesStake/pol.png'
// import metis from '~img/farmsBridgesStake/metis.png'

export const farms = [
  {
    icon: zil,
    name: 'Zilliqa LP (dXCAD)',
    featured: false,
    url: 'https://swap.xcadnetwork.com/',
  },
  {
    icon: zil,
    name: 'Zilliqa LP (ZWAP)',
    featured: false,
    url: 'https://zilswap.io/pools/overview',
  },
  {
    icon: bsc,
    name: 'BSC LP',
    featured: false,
    url: 'https://tokensfarm.com/xcad/lp/13',
  },
  {
    icon: pol,
    name: 'Polygon LP',
    featured: false,
    url: 'https://quickswap.exchange/#/quick',
  },
  {
    icon: eth,
    name: 'ETH LP',
    featured: false,
    url: 'https://farm.xcadnetwork.com/',
  },
]

export const stakes = [
  {
    icon: bsc,
    name: 'XCAD Stake',
    featured: false,
    url: 'https://stake.xcadnetwork.com/',
  },
]

export const bridges = [
  {
    icon: zil,
    name: 'Zilliqa Bridge',
    featured: false,
    url: 'https://xbridge.zilliqa.com/',
  },
  {
    icon: bsc,
    name: 'opBNB Bridge',
    featured: false,
    url: 'https://opbnb-bridge.bnbchain.org/deposit',
  },
  {
    icon: pol,
    name: 'Polygon Bridge',
    featured: false,
    url: 'https://portal.polygon.technology/bridge',
  },
  {
    icon: bsc,
    name: 'BNB Bridge',
    featured: false,
    url: 'https://portalbridge.com/advanced-tools/#/transfer',
  },
]
